import { NgModule } from 'angular-ts-decorators';

@NgModule({
  declarations: [],
  id: 'gn.audio.public.productapi',
  imports: [],
  providers: [],
})
export class ProductApiModule {
}
